import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Profile } from '../models/interfaces/profile.interface';
import { environment } from '../../config/environments/environment';
import { Observable } from 'rxjs';

@Injectable()
export class ProfileService {
  constructor(private http: HttpClient) {}

  public getAll(): Observable<Profile[]> {
    const profile = this.http.get<Profile[]>(`${environment.api.baseUrl}/profiles`)
    return profile
  }

  public getById(id: string): Observable<Profile> {
    return this.http.get<Profile>(`${environment.api.baseUrl}/profiles/${id}`);
  }
}
